import { Component, ChangeDetectionStrategy, Input } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'ld-content-safe',
  template: require('./content-safe.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentSafeComponent {
  @Input('body') body: string

  constructor (private sanitizer: DomSanitizer) {}

  sanitize (body) {
    return this.sanitizer.bypassSecurityTrustHtml(body)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/content-safe/content-safe.component.ts